// extracted by mini-css-extract-plugin
module.exports = {"overlay":"CookieChecker_overlay__eOJ1v","container":"CookieChecker_container__CIvCW"};